export const environment = {
  production: true,
  buildId: '3340888520621701',
  configFile: 'config.json',
};
